import { render } from "./Stores.vue?vue&type=template&id=7d271bed&scoped=true&ts=true"
import script from "./Stores.vue?vue&type=script&lang=ts"
export * from "./Stores.vue?vue&type=script&lang=ts"

import "./Stores.vue?vue&type=style&index=0&id=7d271bed&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d271bed"]])

export default __exports__